/**
 * @ngdoc service
 * @name checkins.factory:updateSelected
 *
 * @description
 *
 */
angular
    .module('festzelt-os.contacts')
    .factory('updateSelectedContacts', [
        '$state',
        updateSelectedContacts
    ]);

function updateSelectedContacts($state) {
    return {
        key: 'update-selected-contacts',
        title: 'Update Selected',
        level: 'selected',
        action: function (payload, store) {
            $state.go('app.contacts.multi-edit', {store: store});
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/contacts/workflows/list-view/update-selected.js